/**
 * PowerPoint add-in constants, grouped by feature.
 *
 * User-facing strings here are the approved copy from the AiVA for PowerPoint
 * Feature & Function Specification v1.1.0.0. Change them only when the spec
 * changes — QA asserts on them verbatim.
 */

/* ═══════════════════════ DI-02 · List speaker notes (AIVA-6756) ═══════════════════════ */

/** Longest notes preview shown per slide before an ellipsis (spec G-7). */
export const NOTES_PREVIEW_MAX_CHARS = 400;

export const SPEAKER_NOTES_COPY = {
  /** Posted in the thread while the deck is being walked. */
  READING: "Reading speaker notes…",
  /** Every slide readable, none has notes (G-7). */
  NONE_SET: "No speaker notes set on any slide.",
  /** No slide's notes could be read on this host (G-7). */
  NONE_READABLE: "AiVA can't read speaker notes in this version of PowerPoint.",
  /** Not in the spec: the presentation has no slides at all. */
  EMPTY_DECK: "This presentation has no slides.",
} as const;

/** "3 slides with notes:" / "1 slide with notes:" */
export function speakerNotesHeader(count: number): string {
  return `${count} ${count === 1 ? "slide" : "slides"} with notes:`;
}

/** Partial-read footnote (G-7): "Notes on 2 slides couldn't be read in this version of PowerPoint." */
export function speakerNotesPartialFootnote(unreadable: number): string {
  return `Notes on ${unreadable} ${unreadable === 1 ? "slide" : "slides"} couldn't be read in this version of PowerPoint.`;
}
